let monthToSpanish = {
  0: 'enero',
  1: 'febrero',
  2: 'marzo',
  3: 'abril',
  4: 'mayo',
  5: 'junio',
  6: 'julio',
  7: 'agosto',
  8: 'septiembre',
  9: 'octubre',
  10: 'noviembre',
  11: 'diciembre',
}

let dayToSpanish = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
  7: 'Domingo',
}

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  singularOrPlural: (number) => {
    return {
      mes: number === '1' ? "Mes" : "Meses",
      dia: number === '1' ? "Día" : "Días",
      hora: number === '1' ? "Hora" : "Horas",
      minuto: number === '1' ? "Minuto" : "Minutos",
    };
  },
  comparers: {
    name: (a, b) => {
      if(a.information.name < b.information.name)
      return -1;
      if(a.information.name > b.information.name)
      return 1;
      return 0;
    },
    area: (a, b) => {
      if(a.information.area.name < b.information.area.name)
      return -1;
      if(a.information.area.name > b.information.area.name)
      return 1;
      return 0;
    },
    leader: (a, b) => {
      if(a.information.leader_first_name < b.information.leader_first_name)
      return -1;
      if(a.information.leader_first_name > b.information.leader_first_name)
      return 1;
      return 0;
    },
    progress: (a, b) => {
      if(a < b)
      return -1;
      if(a > b)
      return 1;
      return 0;
    },
    state: (a, b) => {
      if(a.state < b.state)
      return -1;
      if(a.state > b.state)
      return 1;
      return 0;
    },
    economicImpact: (a, b) => {
      if(a.information.economic_impact < b.information.economic_impact)
      return -1;
      if(a.information.economic_impact > b.information.economic_impact)
      return 1;
      return 0;
    },
    year: (a, b) => {
      if(a.information.start_date < b.information.start_date)
      return -1;
      if(a.information.start_date > b.information.start_date)
      return 1;
      return 0;
    },
    reverse: {
      name: (a, b) => {
        if(a.information.name > b.information.name)
        return -1;
        if(a.information.name < b.information.name)
        return 1;
        return 0;
      },
      area: (a, b) => {
        if(a.information.area.name > b.information.area.name)
        return -1;
        if(a.information.area.name < b.information.area.name)
        return 1;
        return 0;
      },
      leader: (a, b) => {
        if(a.information.leader_first_name > b.information.leader_first_name)
        return -1;
        if(a.information.leader_first_name < b.information.leader_first_name)
        return 1;
        return 0;
      },
      progress: (a, b) => {
        if(a > b)
        return -1;
        if(a < b)
        return 1;
        return 0;
      },
      state: (a, b) => {
        if(a.state > b.state)
        return -1;
        if(a.state < b.state)
        return 1;
        return 0;
      },
      economicImpact: (a, b) => {
        if(a.information.economic_impact > b.information.economic_impact)
        return -1;
        if(a.information.economic_impact < b.information.economic_impact)
        return 1;
        return 0;
      },
      year: (a, b) => {
        if(a.information.start_date > b.information.start_date)
        return -1;
        else if(a.information.start_date < b.information.start_date)
        return 1;
        return 0;
      },
    }
  },
  // lunes 10 de abril
  fullDateFormatter: (paramDate) => {
    var date = new Date(paramDate);
    return dayToSpanish[date.getDay()] + ' ' + date.getDate() + ' de ' + monthToSpanish[date.getMonth()];
  },
  // 10/04/2018
  dashDateFormatter: (paramDate) => {
    var date = new Date(paramDate);
    return date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear();
  },
  // abril de 2018
  dateFormatter: (paramDate) => {
    var date = new Date(paramDate);
    return monthToSpanish[date.getMonth()] + ' de ' + date.getFullYear();
  },
  // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  numberWithDots: (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  numberWithoutDots: (number) => {
    return number.toString().replace(/\,/g, '');
  },
  validEmail: (email) => {
    return re.test(email.toLowerCase());
  },
  // Use example: helpers.groupBy(rawConventions, rawConventions => rawConventions.filter__name, rawConventions => rawConventions.option__name)
  groupBy: (list, keyGetter, valueGetter) => {
    const obj = {};
    list.forEach((item) => {
      const key = keyGetter(item);
      if (!obj[key]) obj[key] = [];
      obj[key].push(valueGetter(item));
    });
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js